import { CallHandle, CallState } from '../index';

export function callHandleActive(callHdl: CallHandle): boolean {
    const endedState = callHdl?.stateHistory?.find(
        (e) => e.state === CallState.Ended,
    );
    const meetingStartedState = callHdl?.stateHistory?.find(
        (e) => e.state === CallState.MeetingStarted,
    );
    const meetingEndedState = callHdl?.stateHistory?.find(
        (e) => e.state === CallState.MeetingEnded,
    );

    return (
        endedState == null &&
        ((meetingStartedState != null && meetingEndedState == null) ||
            (meetingStartedState != null &&
                meetingEndedState != null &&
                +meetingStartedState.timestamp > +meetingEndedState.timestamp))
    );
}
